/*
  Rediseño · buscador de la cabecera con las sugerencias debajo de la barra
  (snippets/grifos-header-search.liquid). Clase propia grifos-busqueda:
  "grifos-buscador" ya es el buscador por estancia del hero. Al escribir pide /search/suggest con la sección
  grifos-busqueda-sugerencias (Section Rendering API) y pinta su HTML en el panel.
  Sin JavaScript sigue siendo un formulario normal: Enter lleva a /search.
*/
/* La cabecera trae dos buscadores (escritorio y móvil) y cada uno carga este fichero: clase sin nombre global
   para que la segunda carga no dé "Identifier has already been declared". */
if (!customElements.get('grifos-busqueda')) customElements.define('grifos-busqueda', class extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.panel = this.querySelector('[data-panel]');
    this.estado = this.querySelector('[data-estado]');
    this.cache = new Map();

    this.input.addEventListener('input', () => {
      clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.buscar(), 200);
    });
    this.input.addEventListener('focus', () => {
      if (this.panel.innerHTML.trim() && this.input.value.trim().length >= 2) this.abrir();
    });
    this.addEventListener('keydown', (e) => this.teclas(e));
    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget)) this.cerrar();
    });
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.cerrar();
    });
  }

  async buscar() {
    const q = this.input.value.trim();
    if (q.length < 2) {
      this.cerrar();
      return;
    }
    if (this.cache.has(q)) {
      this.pintar(this.cache.get(q));
      return;
    }
    if (this.peticion) this.peticion.abort();
    this.peticion = new AbortController();
    const params = new URLSearchParams({
      q,
      'resources[type]': 'product,collection,query',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      section_id: 'grifos-busqueda-sugerencias',
    });
    try {
      const respuesta = await fetch(`${this.dataset.url}?${params}`, { signal: this.peticion.signal });
      if (!respuesta.ok) throw new Error(respuesta.status);
      const doc = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
      const html = doc.querySelector('#GrifosSugerencias')?.outerHTML || '';
      this.cache.set(q, html);
      if (this.input.value.trim() === q) this.pintar(html);
    } catch (error) {
      if (error.name !== 'AbortError') this.cerrar();
    }
  }

  pintar(html) {
    this.panel.innerHTML = html;
    const n = this.panel.querySelectorAll('.grifos-sugerencias__producto').length;
    this.estado.textContent = n ? `${n} productos sugeridos` : 'Sin resultados';
    this.abrir();
  }

  abrir() {
    if (!this.panel.innerHTML.trim()) return;
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  cerrar() {
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
  }

  // Esc cierra; las flechas recorren los enlaces del panel y vuelven a la barra
  teclas(e) {
    if (e.key === 'Escape') {
      this.cerrar();
      this.input.focus();
      return;
    }
    if ((e.key !== 'ArrowDown' && e.key !== 'ArrowUp') || this.panel.hidden) return;
    const enlaces = [...this.panel.querySelectorAll('a')];
    if (!enlaces.length) return;
    e.preventDefault();
    const i = enlaces.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') enlaces[(i + 1) % enlaces.length].focus();
    else if (i <= 0) this.input.focus();
    else enlaces[i - 1].focus();
  }
});
